module.exports = __webpack_public_path__ + "img/time_image.937b9c6f.jpg";